/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_V3_Desc1Inputs */

const en_svc_browser_extensions_v3_desc1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Desc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern manifest V3 architecture with service workers, no legacy patterns that get rejected at review.`)
};

const ar_svc_browser_extensions_v3_desc1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Desc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية Manifest V3 حديثة مع Service Workers، لا أنماط قديمة تُرفض في المراجعة.`)
};

const bn_svc_browser_extensions_v3_desc1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Desc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সার্ভিস ওয়ার্কারসহ আধুনিক Manifest V3 আর্কিটেকচার, রিভিউতে রিজেক্ট হওয়া লিগ্যাসি প্যাটার্ন নেই।`)
};

const de_svc_browser_extensions_v3_desc1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Desc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderne Manifest-V3-Architektur mit Service Workern, keine veralteten Muster, die im Review abgelehnt werden.`)
};

const es_svc_browser_extensions_v3_desc1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Desc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura de manifiesto V3 moderna con service workers, sin patrones heredados que se rechacen en la revisión.`)
};

const fr_svc_browser_extensions_v3_desc1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Desc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture manifeste V3 moderne avec service workers, aucun motif hérité rejeté à la review.`)
};

const pt_svc_browser_extensions_v3_desc1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Desc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura moderna de manifesto V3 com service workers, sem padrões legados rejeitados no review.`)
};

const zh_svc_browser_extensions_v3_desc1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Desc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带 service worker 的现代 Manifest V3 架构，没有过审会被打回的老写法。`)
};

const tr_svc_browser_extensions_v3_desc1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Desc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service worker'larla modern manifest V3 mimarisi, incelemede reddedilen eski kalıplar yok.`)
};

const ru_svc_browser_extensions_v3_desc1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Desc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Современная архитектура манифеста V3 с сервис-воркерами, без legacy-паттернов, отклоняемых на ревью.`)
};

const pl_svc_browser_extensions_v3_desc1 = /** @type {(inputs: Svc_Browser_Extensions_V3_Desc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowoczesna architektura manifestu V3 z service workerami, bez legacy patternów odrzucanych na review.`)
};

/**
* | output |
* | --- |
* | "Modern manifest V3 architecture with service workers, no legacy patterns that get rejected at review." |
*
* @param {Svc_Browser_Extensions_V3_Desc1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_v3_desc1 = /** @type {((inputs?: Svc_Browser_Extensions_V3_Desc1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_V3_Desc1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_v3_desc1(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_v3_desc1(inputs)
	if (locale === "de") return de_svc_browser_extensions_v3_desc1(inputs)
	if (locale === "es") return es_svc_browser_extensions_v3_desc1(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_v3_desc1(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_v3_desc1(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_v3_desc1(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_v3_desc1(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_v3_desc1(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_v3_desc1(inputs)
	return en_svc_browser_extensions_v3_desc1(inputs)
});
export { svc_browser_extensions_v3_desc1 as "svc_browser-extensions_V3_desc" }